import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import MetaImage from 'img/landing/outlier-helmet.webp';

import Helmet from './Helmet';

const Title = 'Outlier Case Study | Canny';
const Description =
  'Read about how Outlier scored big with product-led growth and community engagement.';
const OutlierUrl = 'https://canny.io/case-studies/outlier';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${OutlierUrl}#webpage`,
    url: OutlierUrl,
    name: 'Case Study: Outlier × Canny',
    description: 'How Outlier scored big with product-led growth and community engagement.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${OutlierUrl}#article`,
    genre: 'Case Study',
    headline: 'How Outlier scored big with product-led growth and community engagement',
    description:
      'Outlier, a sports betting app, encountered overwhelming feedback—hundreds of pieces a week—making it hard to align across teams. Canny solved this with streamlined feedback collection, prioritization, roadmapping, and update workflows. The team uses Intercom and Linear integrations to triage and merge similar requests. Metrics like weekly posts, comments, votes, and status changes are now key markers of how well their growth engine is humming.',
    inLanguage: 'en',
    url: OutlierUrl,
    mainEntityOfPage: { '@id': `${OutlierUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Outlier', url: 'https://outlier.bet' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Outlier', item: OutlierUrl },
  ]),
]);

export default class OutlierLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: MetaImage },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: OutlierUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: MetaImage },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
